export default function beautifyJson(json) {
  try {
    if (!json) return

    return JSON.stringify(JSON.parse(json), null, '   ')
  } catch (error) {
    return json
  }
}
